import type { ButtonProps } from './type'
import { Button } from './Button'
import { COLOR } from 'app-v2/design-tokens'
import React from 'react'

export const PrimaryButton = (props: ButtonProps) => (
    <Button
        {...props}
        variant="contained"
        buttonColor={COLOR.PRIMARY}
        labelColor={COLOR.SECONDARY}
        onClick={props.onClick}>
        {props.children}
    </Button>
)

export const PrimaryButtonOutlined = (props: ButtonProps) => (
    <Button
        {...props}
        variant="outlined"
        buttonColor={COLOR.PRIMARY}
        labelColor={COLOR.PRIMARY}
        onClick={props.onClick}>
        {props.children}
    </Button>
)

export const GhostButton = (props: ButtonProps) => (
    <Button
        {...props}
        variant="text"
        labelColor={COLOR.PRIMARY}
        onClick={props.onClick}>
        {props.children}
    </Button>
)
